// export default function highlightKeyword(
//   text: string,
//   searchTerm: string[]
// ): string {
//   try {
//     let highlightedText = "";
//     let pharseSearch = [];
//     let normalSearch = [];

//     const sanitizedSearchTerm = searchTerm.map((str) =>
//       str.replace(/\s+/g, " ").trim()
//     );

//     for (let str of sanitizedSearchTerm) {
//       if (str.charAt(0) === `"` && str.slice(-1) === `"`) {
//         let keyword = str.replace(/['"]+/g, "");
//         pharseSearch.push(keyword);
//       } else {
//         let keyword = str.split(" ");
//         normalSearch.push(...keyword);
//       }
//     }

//     if (pharseSearch.length) {
//       highlightedText = text.replace(
//         new RegExp(`\\b(${pharseSearch?.join("|")})\\b`, "gi"),
//         "<mark>$1</mark>"
//       );
//     }
//     if (normalSearch.length) {
//       //Removing stop words from highlighting
//       //Selecting and/or keywords
//       let wordsToRemove = ["and", "or"];
//       normalSearch = normalSearch.filter(word => !wordsToRemove.includes(word.toLowerCase()));
//       // highlighting the rest of the words.
//       highlightedText = text.replace(
//         new RegExp(`\\b(${normalSearch?.join("|")})\\b`, "gi"),
//         "<mark>$1</mark>"
//       );
//     }

//     if (!sanitizedSearchTerm.toString()) return text;

//     return highlightedText;
//   } catch (err) {
//     console.log(err);
//     return text;
//   }
// }

// export default function highlightKeyword(
//   text: string,
//   searchTerm: string[]
// ): string {
//   try {
//     let highlightedText = text?.trim();
//     let pharseSearch: string[] = [];
//     let normalSearch: string[] = [];
//     let newNormalSearch: string[] = [];

//     // Sanitize search terms
//     const sanitizedSearchTerm = searchTerm.map((str) =>
//       str.replace(/\s+/g, " ").trim()
//     );

//     // Classify into phrase and normal search
//     for (let str of sanitizedSearchTerm) {
//       if (str.includes("AND")) {
//         const phraseMatches = Array.from(str.matchAll(/"([^"]+)"/g)).map((m) =>
//           m[1].trim()
//         );

//         // Remove quoted phrases from input and split remaining by space
//         const cleaned = str
//           .replace(/"[^"]+"/g, "")
//           .replace(/\s+(AND|OR)\s+/gi, " ")
//           .trim();
//         const keywords = cleaned
//           .split(/\s+/)
//           .map((w) => w.trim())
//           .filter((w) => w && !["and", "or"].includes(w.toLowerCase()));

//         newNormalSearch = [...keywords, ...phraseMatches];
//       } else if (str.startsWith(`"`) && str.endsWith(`"`)) {
//         const keyword = str.replace(/['"]+/g, "").trim();
//         if (keyword) pharseSearch.push(keyword);
//       } else {
//         const keywordParts = str
//           .split(" ")
//           .map((s) => s.trim())
//           .filter((s) => s.length > 0);
//         normalSearch.push(...keywordParts);
//       }
//     }

//     // Remove empty strings just in case
//     pharseSearch = pharseSearch.filter((s) => s.length > 0);
//     normalSearch = normalSearch.filter((s) => s.length > 0);

//     // Remove common stop words
//     const wordsToRemove = ["and", "or"];
//     normalSearch = normalSearch.filter(
//       (word) => !wordsToRemove.includes(word.toLowerCase())
//     );

//     // Highlight phrase matches
//     if (pharseSearch.length) {
//       const phrasePattern = pharseSearch
//         .map((term) => term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")) // escape regex
//         .join("|");
//       highlightedText = highlightedText.replace(
//         new RegExp(`\\b(${phrasePattern})\\b`, "gi"),
//         "<mark>$1</mark>"
//       );
//     }

//     // Highlight individual keyword matches
//     if (normalSearch.length) {
//       const keywordPattern = normalSearch
//         .map((term) => term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")) // escape regex
//         .join("|");
//       // console.log(keywordPattern)
//       highlightedText = highlightedText.replace(
//         new RegExp(`\\b(${keywordPattern})\\b`, "gi"),
//         "<mark>$1</mark>"
//       );
//     }
//     if (newNormalSearch.length) {
//       const keywordPattern = newNormalSearch.join("|");
//       highlightedText = highlightedText.replace(
//         new RegExp(`\\b(${keywordPattern})\\b`, "gi"),
//         "<mark>$1</mark>"
//       );
//     }

//     return highlightedText;
//   } catch (err) {
//     console.log("Error in highlightKeyword:", err);
//     return text;
//   }
// }

export default function highlightKeyword(
  text: string,
  searchTerm: string[]
): string {
  try {
    let pharseSearch: string[] = [];
    let normalSearch: string[] = [];
    let newNormalSearch: string[] = [];

    // Sanitize search terms
    const sanitizedSearchTerm = searchTerm.map((str) =>
      str.replace(/\s+/g, " ").trim()
    );

    for (let str of sanitizedSearchTerm) {
      if (str.includes("AND")) {
        const phraseMatches = Array.from(str.matchAll(/"([^"]+)"/g)).map((m) =>
          m[1].trim()
        );
        const cleaned = str
          .replace(/"[^"]+"/g, "")
          .replace(/\s+(AND|OR)\s+/gi, " ")
          .trim();
        const keywords = cleaned
          .split(/\s+/)
          .map((w) => w.trim())
          .filter((w) => w && !["and", "or"].includes(w.toLowerCase()));
        newNormalSearch = [...keywords, ...phraseMatches];
      } else if (str.startsWith(`"`) && str.endsWith(`"`)) {
        const keyword = str.replace(/['"]+/g, "").trim();
        if (keyword) pharseSearch.push(keyword);
      } else {
        const keywordParts = str
          .split(" ")
          .map((s) => s.trim())
          .filter((s) => s.length > 0);
        normalSearch.push(...keywordParts);
      }
    }

    pharseSearch = pharseSearch.filter((s) => s.length > 0);
    normalSearch = normalSearch.filter((s) => s.length > 0);
    const wordsToRemove = ["and", "or"];
    normalSearch = normalSearch.filter(
      (word) => !wordsToRemove.includes(word.toLowerCase())
    );

    // NEW: Split LaTeX $$...$$ blocks to avoid highlighting inside them
    const latexRegex = /\$\$(.+?)\$\$/gs;
    const parts: string[] = [];
    let lastIndex = 0;
    let match;

    while ((match = latexRegex.exec(text)) !== null) {
      if (match.index > lastIndex) {
        parts.push(text.slice(lastIndex, match.index)); // plain text
      }
      parts.push(`$$${match[1]}$$`); // preserve math
      lastIndex = latexRegex.lastIndex;
    }

    if (lastIndex < text.length) {
      parts.push(text.slice(lastIndex));
    }

    //  Apply highlighting ONLY to non-math parts
    const highlightedParts = parts.map((part) => {
      if (part.startsWith("$$") && part.endsWith("$$")) return part; // math block

      let highlighted = part;

      if (pharseSearch.length) {
        const phrasePattern = pharseSearch
          .map((term) => term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
          .join("|");
        highlighted = highlighted.replace(
          new RegExp(`\\b(${phrasePattern})\\b`, "gi"),
          "<mark>$1</mark>"
        );
      }

      if (normalSearch.length) {
        const keywordPattern = normalSearch
          .map((term) => term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
          .join("|");
        highlighted = highlighted.replace(
          new RegExp(`\\b(${keywordPattern})\\b`, "gi"),
          "<mark>$1</mark>"
        );
      }

      if (newNormalSearch.length) {
        const keywordPattern = newNormalSearch
          .map((term) => term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
          .join("|");
        highlighted = highlighted.replace(
          new RegExp(`\\b(${keywordPattern})\\b`, "gi"),
          "<mark>$1</mark>"
        );
      }

      return highlighted;
    });

    return highlightedParts.join("");
  } catch (err) {
    console.log("Error in highlightKeyword:", err);
    return text;
  }
}

export function keywordHighlight(
  keywordData: any,
  searchTerm: string[],
  article_id: string,
  title: string
): string {
  try {
    let string = "";
    let isArticlePresent = Object.keys(keywordData).includes(article_id);

    if (isArticlePresent && keywordData[article_id.toString()].title_fz) {
      if (keywordData[article_id.toString()].title_fz) {
        if (Array.isArray(keywordData[article_id.toString()].title_fz))
          string = keywordData[article_id.toString()].title_fz[0];
      }
    } else if (string === "") {
      string = highlightKeyword(title, searchTerm);
    } else {
      string = title;
    }
    return string;
  } catch (err) {
    console.log(err);
    return "";
  }
}

// Function used in abstract page to highlight keywords section
export function highlightKeys(text: string, searchTerm: string[]): string {
  try {
    // let highlightedText = "";
    let highlightedText = text;
    let pharseSearch = [];
    let normalSearch = [];
    let newNormalSearch: string[] = [];
    for (let str of searchTerm) {
      //---------DF-2761
      str = str.trim();
      if (str.includes("AND")) {
        const phraseMatches = Array.from(str.matchAll(/"([^"]+)"/g)).map((m) =>
          m[1].trim()
        );
        // Remove quoted phrases from input and split remaining by space
        const cleaned = str.replace(/"[^"]+"/g, "").trim();
        const keywords = cleaned.split(/\s+/).map((w) => w.trim());
        // .filter(w => w && !['and', 'or'].includes(w.toLowerCase()));

        newNormalSearch = [...phraseMatches, ...keywords];
      } else if (!str) continue;
      //---------DF-2761
      if (str.charAt(0) === `"` && str.slice(-1) === `"`) {
        let keyword = str.replace(/['"]+/g, "").trim();
        //---------DF-2761
        if (keyword) pharseSearch.push(keyword);
        // pharseSearch.push(keyword);
      } else {
        // let keyword = str.split(" ");
        let words = str
          .split(/\s+/)
          .map((word) => word.trim())
          .filter(Boolean);
        normalSearch.push(...words);
      }
    }
    let combinedArr = [...pharseSearch, ...normalSearch]
      .filter(Boolean)
      .map((str) => str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")); // escape regex;

    if (newNormalSearch.length) {
      const keywordPattern = new RegExp(
        `( ${newNormalSearch.join("|")} )`,
        "gi"
      );
      highlightedText = highlightedText.replace(
        keywordPattern,
        "<mark>$1</mark>"
      );
    }
    if (combinedArr.length) {
      //---------DF-2761
      highlightedText = text.replace(
        new RegExp(`\\b(${combinedArr?.join("|")})\\b`, "gi"),
        "<mark>$1</mark>"
      );

      // const regex = new RegExp(`(${combinedArr.join("|")})`, "gi");
      // highlightedText = highlightedText.replace(regex, "<mark>$1</mark>");
    }

    if (!searchTerm.toString()) return text;

    return highlightedText;
  } catch (err) {
    console.log(err);
    return text;
  }
}

// Highlight abstract
export function highlightAbstract(
  keywordData: any,
  searchTerm: string[],
  article_id: string,
  abstract: string
): string {
  try {
    let string = "";
    let isArticlePresent = Object.keys(keywordData).includes(article_id);

    if (isArticlePresent && keywordData[article_id.toString()].abstract) {
      if (keywordData[article_id.toString()].abstract) {
        // if (Array.isArray(keywordData[article_id.toString()].abstract))
        //   string = highlightKeyword(
        //     keywordData[article_id.toString()].abstract[0],
        //     searchTerm
        //   );

        if (Array.isArray(keywordData[article_id.toString()].abstract)) {
          const abs = keywordData[article_id.toString()].abstract[0];

          //NEW LOGIC — split by newline and highlight each part
          string = abs
            .split("\n")
            .map((p: any) => highlightKeyword(p, searchTerm))
            .join("<br/>");
        }
      }
    } else if (string === "") {
      // string = highlightKeyword(abstract, searchTerm);
      // NEW LOGIC for fallback abstract also
      string = abstract
        .split("\n")
        .map((p) => highlightKeyword(p, searchTerm))
        .join("<br/><br/>");
    } else {
      string = abstract;
    }

    return string;
  } catch (err) {
    console.log(err);
    return "";
  }
}

export function highlightAbstractKeyword(
  keywordData: any,
  searchTerm: string[],
  article_id: string,
  abstract: string
): string {
  try {
    let string = "";
    let isArticlePresent = Object.keys(keywordData).includes(article_id);

    if (isArticlePresent && keywordData[article_id.toString()].abstract) {
      if (keywordData[article_id.toString()].abstract) {
        if (Array.isArray(keywordData[article_id.toString()].abstract))
          string = highlightKeyword(
            keywordData[article_id.toString()].abstract[0],
            searchTerm
          );
      }
    } else if (string === "") {
      string = highlightKeyword(abstract, searchTerm);
    } else {
      string = abstract;
    }

    return string;
  } catch (err) {
    console.log(err);
    return "";
  }
}

// Highlight abstract
export function highlightKeyWordsInAbtract(
  keywordData: any,
  searchTerm: string[],
  article_id: string,
  abstract: string
): string {
  try {
    let string = "";
    let isArticlePresent = Object.keys(keywordData).includes(article_id);

    if (isArticlePresent && keywordData[article_id.toString()].abstract) {
      if (keywordData[article_id.toString()].abstract) {
        if (Array.isArray(keywordData[article_id.toString()].abstract))
          string = highlightKeyword(
            keywordData[article_id.toString()].abstract[0],
            searchTerm
          );
      }
    } else if (string === "") {
      string = highlightKeyword(abstract, searchTerm);
    } else {
      string = abstract;
    }

    return string;
  } catch (err) {
    console.log(err);
    return "";
  }
}

// utils/splitTitleWithMath.ts
export const splitTitleWithMath = (text: string) => {
  const regex = /\$\$(.+?)\$\$/g;
  const parts: (string | { math: string })[] = [];
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.substring(lastIndex, match.index)); // normal text
    }
    parts.push({ math: match[1] }); // math content without $$
    lastIndex = regex.lastIndex;
  }

  if (lastIndex < text.length) {
    parts.push(text.substring(lastIndex));
  }

  return parts;
};

export const safeKeywordHighlightAndSplit = (
  keywordData: any,
  searchTerm: string[],
  article_id: string,
  title: string
): (string | { math: string })[] => {
  const parts = splitTitleWithMath(title);

  return parts.map((part) => {
    if (typeof part === "string") {
      // Apply highlighting only to non-math text
      return highlightKeyword(part, searchTerm);
    } else {
      // Return math part untouched
      return part;
    }
  });
};
